var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"optinisation-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('optinisation.title')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('optinisation.subtitle', { client: 'CLIENT_NAME' }))}})])}
var staticRenderFns = []

export { render, staticRenderFns }